
import { Link } from "react-router-dom";
import { Facebook, Linkedin, Mail } from "lucide-react";
import { OptimizedImage } from "@/components/ui/image";
import { useData } from "@/contexts/DataContext";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { navigationLinks } = useData();
  
  // Filter only visible navigation links
  const visibleLinks = navigationLinks.filter(link => link.visible);

  return (
    <footer className="bg-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col justify-center">
            <div className="flex justify-center md:justify-start">
              <Link to="/">
                <OptimizedImage
                  src="/lovable-uploads/0b8768c3-e86a-40d9-a11e-7fb5e194c5af.png" 
                  alt="Freelance With Andy Logo" 
                  className="h-[75px] w-auto object-contain"
                  width={201}
                  height={75}
                />
              </Link>
            </div>
            <p className="text-gray-600 mb-4">
              The go-to resource for freelancers with expert insights and actionable strategies for success.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/AndrewNady2020" target="_blank" rel="noopener noreferrer" className="text-brand-gray hover:text-brand-green" aria-label="Visit our Facebook page">
                <Facebook size={20} />
              </a>
              <a href="https://www.linkedin.com/in/andrew-n-9b3030135/" target="_blank" rel="noopener noreferrer" className="text-brand-gray hover:text-brand-green" aria-label="Visit our LinkedIn profile">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-brand-green mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {visibleLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-600 hover:text-brand-green">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold text-brand-green mb-4">Contact</h3>
            <div className="flex items-center mb-2">
              <Mail size={16} className="mr-2 text-brand-gray" />
              <a href="mailto:me@freelancewithandy.com" className="text-gray-600 hover:text-brand-green">me@freelancewithandy.com</a>
            </div>
            <p className="text-gray-600 mt-4">
              Ready to start a project? <Link to="/contact" className="text-brand-green font-medium hover:underline">Get in touch</Link>
            </p>
            <div className="mt-6 space-y-2">
              <Link to="/privacy-policy" className="text-gray-600 hover:text-brand-green block">Privacy Policy</Link>
              <Link to="/terms-of-service" className="text-gray-600 hover:text-brand-green block">Terms of Service</Link>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-gray-600 text-center">
            © {currentYear} Freelance With Andy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
